module.exports = __webpack_public_path__ + "static/media/Walls.784769c1.jpg";